import type { ClientMetricsData } from '../../../services/metricsApi';

export const clusterData = (
    data: ClientMetricsData[]
): {
    success: ClientMetricsData[];
    successOutdated: ClientMetricsData[];
    failure: ClientMetricsData[];
    failureOutdated: ClientMetricsData[];
    other: ClientMetricsData[];
} => {
    const success: ClientMetricsData[] = [];
    const successOutdated: ClientMetricsData[] = [];
    const failure: ClientMetricsData[] = [];
    const failureOutdated: ClientMetricsData[] = [];
    const other: ClientMetricsData[] = [];
    for (const it of data) {
        if (it.statusCode.startsWith('2')) {
            if (isInactiveSince7Days(it)) {
                successOutdated.push(it);
            } else {
                success.push(it);
            }
        } else if (it.statusCode.startsWith('4') || it.statusCode.startsWith('5')) {
            if (isInactiveSince7Days(it)) {
                failureOutdated.push(it);
            } else {
                failure.push(it);
            }
        } else {
            other.push(it);
        }
    }
    return { success, successOutdated, failure, failureOutdated, other };
};

export const isInactiveSince7Days = (clientMetricsData: ClientMetricsData): boolean => {
    const lastSeen = new Date(clientMetricsData.lastSeen);
    const sevenDaysAgo = new Date(); // actually now here
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 7);
    return lastSeen < sevenDaysAgo;
};
